import React, { Component } from 'react';
import { Row, Col, Button, Image, Modal } from 'react-bootstrap';
import PlansImage from '../../../Images/plans.svg';
import EstimatedWalletsImage from '../../../Images/estimated_balance.svg';
import WalletsRestantesImage from '../../../Images/wallets_restantes.svg';
import AddressesRestamtesImage from '../../../Images/addresses_restantes.svg';

class PlanInformationIndex extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  redirectPlans() {
    this.props.data.history.push('/kyc');
  }

  wallets_restantes() {
    const self = this;
    var result = 0;
    var wallets_usadas = 0;
    var total_wallets = self.props.coinsInfo.length * self.props.planInfo.wallets_per_coin;

    self.props.coinsInfo.forEach(element => {
      wallets_usadas += element.wallets;
    });
    result = total_wallets - wallets_usadas;
    return result;
  }

  addresses_restantes() {
    const self = this;
    var result = 0;
    var addresses_usadas = 0;
    var total_addresses = self.props.coinsInfo.length * self.props.planInfo.addresses_per_coin;

    self.props.coinsInfo.forEach(element => {
      addresses_usadas += element.addresses;
    });
    result = total_addresses - addresses_usadas;
    return result;
  }

  balance_usd_total() {
    const self = this;
    var result = 0;
    self.props.coinsInfo.forEach(element => {
      result = result + Number(element.balance_usd);
    });
    return result + Number(this.props.balance_virtual);
  }

  render() {
    let language = localStorage.getItem('lan');
    return (
      <Row>
        <Modal
        size="lg"
        show={this.state.showModal}
        onHide={() => this.setState({ showModal: false })}
        >
          <div style={{padding:"2em"}}>
            <p> Depósito de Virtual MXN</p>
            <p> El depósito puede tardar hasta 24 horas en verse reflejado</p>
            <Button
              className="wirebit-transfer-generals-button"
              variant="primary"
              style={{marginTop:"1em"}}
              onClick={() => {
                const newWindow = window.open('https://centum.efevoopay.com/pagoCheckout?token=YUANFJJQS59F&Hash=I1nOHwLquGJPbkxefOKrtw==', '_blank', 'noopener,noreferrer');
                if (newWindow) newWindow.focus();
                this.setState({ showModal: false });
              }}
            >
              Continuar
            </Button>
          </div>
        </Modal>
        <Col md={12} lg={{span:4,offset:1}}>
          <div className="container_information_wallets_hired_plan">
            <Row>
              {
                (this.props.ClientInfo?.type == 'free')
                ?
                  <>
                    <Col sm={6} xs={12}>
                      <p style={{ marginBottom: 0, color: "#FFFFFF", fontWeight: "bold", fontSize: 25 }}></p>
                      <p style={{ marginBottom: 0, color: "#FFFFFF" ,  fontWeight: "bold"}}>{this.props.traductions.banner_FinishRegis}</p>
                    </Col>
                    <Col sm={6} xs={12} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                      <Button className="add-wallets-generals-button"  onClick={() => { this.redirectPlans() }}>{this.props.traductions.banner_btnComplete}</Button>
                    </Col>
                  </>
                :
                  <>
                    <Col sm={12} xs={12}>
                        <p style={{ marginBottom: 0, color: "#FFFFFF", fontWeight: "bold", fontSize: 25 }}>{this.props.traductions.banner_AccountType}</p>
                        <p style={{ marginBottom: 0, color: "#FFFFFF" }}>
                          {this.props.traductions.banner_CurrentAccount1} <strong style={{textTransform:'capitalize'}}>{this.props.planInfo.name}</strong> {(this.props.traductions.banner_CurrentAccount2)&& language === 'en' && this.props.traductions.banner_CurrentAccount2}
                        </p>
                        <Button
                            className="wirebit-transfer-generals-button"
                            variant="primary"
                            style={{marginTop:"1em"}}
                            onClick={() => {
                              this.setState({showModal:true})
                            }}
                          >
                            Depositar Virtual MXN
                          </Button>
                      </Col>
                  </>
              }
            </Row>
          </div>
        </Col>
        <Col md={4} lg={2}>
          <div className="container-cards-wallets-generals">
            <div style={{ textAlign: "center" }}>
              <div className="container_icons_information_wallets_display_flex">
                <div className="container_icons_information_wallets">
                  <Image src={EstimatedWalletsImage} />
                </div>
              </div>
              <p className="information_wallets_title">${this.balance_usd_total().toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
              <p className="information_wallets_text">{this.props.traductions.data_aproxBalance}</p>
            </div>
          </div>
        </Col>
        <Col md={4} lg={2}>
          <div className="container-cards-wallets-generals">
            <div style={{ textAlign: "center" }}>
              <div className="container_icons_information_wallets_display_flex">
                <div className="container_icons_information_wallets">
                  <Image src={WalletsRestantesImage} />
                </div>
              </div>
              <p className="information_wallets_title">{this.wallets_restantes()}</p>
              <p className="information_wallets_text">{this.props.traductions.data_Wallets}</p>
            </div>
          </div>
        </Col>
        <Col md={4} lg={2}>
          <div className="container-cards-wallets-generals">
            <div style={{ textAlign: "center" }}>
              <div className="container_icons_information_wallets_display_flex">
                <div className="container_icons_information_wallets">
                  <Image src={AddressesRestamtesImage} />
                </div>
              </div>
              <p className="information_wallets_title">{this.addresses_restantes()}</p>
              <p className="information_wallets_text">{this.props.traductions.data_Addresses}</p>
            </div>
          </div>
        </Col>
      </Row>
    );
  }

} export default PlanInformationIndex;
